import './Login.css';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';

const Login = () => {
    //Al inicio redireccion
    useEffect(() => {
        setTimeout(() => {
            window.location = process.env.REACT_APP_LOGIN_URL;
        }, 3000);
    }, []);
    //Render
    return (
        <div className="w-100 vertical-centered">
            <div className="d-flex justify-content-center">
                <div className="row">
                    <div className="col-12 d-flex justify-content-center mb-4">
                        <div className="icon-module icon-module-color">
                            <FontAwesomeIcon icon={faSearch} className="h1 mt-2" />
                        </div>
                    </div>
                    <div className="col-12 d-flex justify-content-center">
                        <h2>{ process.env.REACT_APP_NAME }</h2>
                    </div>
                    <div className="col-12 d-flex justify-content-center">
                        <h6 className="text-muted">Debe iniciar sesión, espera a ser redireccionado o haga click <a href={ process.env.REACT_APP_LOGIN_URL }>aquí</a></h6>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;